/* eslint-disable */
import React, { Suspense } from 'react'
import { Navigate, Route, Routes as SwitchRoute, useLocation } from 'react-router-dom'

// import routes
import { authProtectedRoutes, publicRoutes } from './routes'

// import layouts
import AuthLayout from '../layouts/AuthLayout/'
import NonAuthLayout from '../layouts/NonAuth'
import { Spinner } from '../components/Spinner'

const AuthProtected = props => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const companyId = searchParams.get('companyId') || ''

  if (props.isAuthProtected && !localStorage.getItem('devchat_app_userAuthenticated')) {
    return <Navigate to={`/sign-in${companyId ? `?companyId=${encodeURIComponent(companyId)}` : ''}`} replace />
  }

  const isSelectCampaignPage = location.pathname === '/select-campaign'
  const isSelectDepartmentPage = location.pathname === '/select-department'

  // A link from the admin can target a different company than the last one
  // selected in this browser. Rebuild the operator's campaign/department scope
  // before mounting ChatPage with stale persisted permissions.
  if (props.isAuthProtected && companyId && !isSelectCampaignPage && !isSelectDepartmentPage) {
    const savedCompanyId = localStorage.getItem('devchat_app_selectedCompanyId')
    if (savedCompanyId !== companyId) {
      return <Navigate to={`/select-campaign?companyId=${encodeURIComponent(companyId)}`} replace />
    }
  }

  if (props.isAuthProtected && !companyId && !isSelectCampaignPage && !isSelectDepartmentPage) {
    const savedCompanyId = localStorage.getItem('devchat_app_selectedCompanyId')
    if (savedCompanyId) {
      const nextPath = location.pathname === '/' ? '/chat-page' : location.pathname
      return <Navigate to={`${nextPath}?companyId=${savedCompanyId}`} replace />
    }
    return <Navigate to={{ pathname: `/select-campaign`, state: { from: props.location } }} />
  }

  return <>{props.children}</>
}
/**
 * Main Route component
 */
const Routes = () => {
  return (
    // rendering the router with layout
    <React.Fragment>
      <Suspense fallback={<Spinner fullScreen />}>
        <SwitchRoute>
          {/* public routes */}
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              exact={route.exact}
              layout={NonAuthLayout}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              isAuthProtected={false}
            />
          ))}

          {/* private/auth protected routes */}
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              layout={AuthLayout}
              element={
                <AuthProtected isAuthProtected={true}>
                  <AuthLayout>{route.component}</AuthLayout>
                </AuthProtected>
              }
              key={idx}
              isAuthProtected={true}
            />
          ))}
        </SwitchRoute>
      </Suspense>
    </React.Fragment>
  )
}

export default Routes
